// extracted by mini-css-extract-plugin
module.exports = {"clock":"Countdown_clock__1wJSq","spanWrapper":"Countdown_spanWrapper__2XgAE","text":"Countdown_text__3sLxx","time":"Countdown_time__1I5iY","separator":"Countdown_separator__38_Xj"};